import { FlexStyled } from "./flex.styles";

export { default } from "./flex";
export { FlexStyled };
